import "bootstrap";

export function initializeBootstrap() {
  const ios = () => {
    if (typeof window === `undefined` || typeof navigator === `undefined`)
      return false;

    return /iPhone|iPad|iPod/i.test(
      navigator.userAgent ||
        navigator.vendor ||
        (window.opera && opera.toString() === `[object Opera]`)
    );
  };

  $(function () {
    if (!ios()) {
      $('[data-toggle="tooltip"]').tooltip();
    }
  });
}
